// export const CHAT_LIST = [
//     {
//         id: '@vasya111',
//         name: 'Василий',
//     },
//     {
//         id: '@pet_ersov',
//         name: 'Пётр',
//     },
//     {
//         id: '@alex_123',
//         name: 'Александр',
//     },
//     {
//         id: '@seriy',
//         name: 'Сергей',
//     },
//     {
//         id: '@dima2',
//         name: 'Дмитрий',
//     },
// ];

export const CHAT_LIST = {
    chats: {},
};
